import { render, staticRenderFns } from "./dollar.vue?vue&type=template&id=07c439bc&"
import script from "./dollar.vue?vue&type=script&lang=js&"
export * from "./dollar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports